export default __webpack_public_path__ + "static/media/settings.42993b28.svg";